<template>
    <div>
        <div class="pt-2 pr-2">
          <div class="pt-2 text-center pr-2">
            <base-button
              type="info" 
              icon="ni ni-fat-add"
              class="mb-3"
              @click="showSubscriberModal()">NEW SUBSCRIBER</base-button>
          </div>
          <table>
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody v-if="subscribers.length > 0">
              <tr v-for="(subscriber, index) in subscribers" :key="index">
                <td data-label="Name">
                  {{ subscriber.firstName }} {{ subscriber.lastName }}
                </td>
                <td data-label="Email">
                    <a :href="'mailto:' + subscriber.email">{{ subscriber.email }}</a>
                </td>
                <td data-label="Phone">
                  <a :href="'tel:' + subscriber.phone">{{ subscriber.phone }}</a>
                </td>
                <td data-label="Actions">
                  <base-button
                    type="warning"
                    icon="fa fa-pencil"
                    size="sm"
                    rounded
                    @click="editSubscriber(subscriber)"></base-button>
                  <base-button
                    type="danger"
                    icon="fa fa-trash"
                    size="sm"
                    rounded
                    @click="deleteSubscriber(subscriber.id)"></base-button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <modal :show.sync="modal"
          modal-classes="modal-dialog-centered modal-lg">
          <h6 slot="header" class="modal-title" id="modal-title-default">
            <strong>MANAGE SUBSCRIBERS</strong>
          </h6>
          <template>
              <form role="form" style="background: #eee;">
                <div class="row">
                    <div class="col-md-6">
                        <base-input alternative
                            ref="firstName"
                            type="text"
                            placeholder="First Name"
                            autofocus
                            :valid="form.valid"
                            v-model="form.firstName"
                            addon-left-icon="fa fa-user">
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <base-input alternative
                            ref="lastName"
                            type="text"
                            placeholder="Last Name"
                            :valid="form.valid"
                            v-model="form.lastName"
                            addon-left-icon="fa fa-user">
                        </base-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <base-input alternative
                            ref="email"
                            type="email"
                            placeholder="Email"
                            autocomplete="off"
                            :valid="form.valid"
                            v-model="form.email"
                            addon-left-icon="fa fa-at">
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <base-input alternative
                            ref="phone"
                            type="phone"
                            placeholder="Phone"
                            :valid="form.valid"
                            v-model="form.phone"
                            addon-left-icon="fa fa-phone">
                        </base-input>
                    </div>
                </div>
              </form>
          </template>
          <template slot="footer">
            <base-button type="success" @click="saveSubscriber()">Save changes</base-button>
          </template>
        </modal>
    </div>
</template>

<script>
import axios from 'axios'
import Modal from "@/components/Modal"
export default {
  name: "subscribers",
  components: {
    Modal
  },
  data() {
    return {
      subscribers: [],
      modal: false,
      form: {
        valid: false,
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      }
    }
  },
  mounted () {
    let vm = this
    vm.load()
  },
  methods: {
    load () {
      let vm = this
      axios.get(process.env.VUE_APP_API_URL + 'subscribers/all').then(function (response) {
        vm.subscribers = response.data.data
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
    },
    resetModalform () {
      this.form = {
        valid: false,
        id: 0,
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      }
    },
    showSubscriberModal () {
        let vm = this
        vm.modal=true
        vm.resetModalform()
        setTimeout(x => {
            vm.$nextTick(() => vm.$refs.firstName.focus())
        }, 1000);
    },
    editSubscriber (subscriber) {
        let vm = this
        vm.modal=true
        vm.form.id = subscriber.id
        vm.form.firstName = subscriber.firstName
        vm.form.lastName = subscriber.lastName
        vm.form.email = subscriber.email
        vm.form.phone = subscriber.phone
        setTimeout(x => {
            vm.$nextTick(() => vm.$refs.domain.focus())
        }, 2000);
    },
    saveSubscriber () {
      let vm = this
      let url = (vm.form.id == 0) ? 'subscribers/add' : 'subscribers/edit/' + vm.form.id
      axios.post(process.env.VUE_APP_API_URL + url, vm.form).then(function (response) {
        vm.load()
        vm.modal = false
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
    },
    deleteSubscriber (id) {
      let vm = this
      if (confirm('Are you sure that you want delete this subscriber ?')) {
        axios.delete(process.env.VUE_APP_API_URL + 'subscribers/delete/' + id).then(function (response) {
          vm.load()
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      }
    }
  }
};
</script>
<style>
  @import '../../assets/table.css';
  .modal-body {
    background: #eee;
  }
</style>
